<template>
  <!-- <HelloWorld /> -->
  <div class="home">
    <!-- <h1 class="mx-3 my-3 font-weight-regular headline">Homepage</h1> -->


    <v-layout row wrap align-center justify-center class="mt-5">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
        <v-card class="text-xs-center ma-3" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">
          <v-card-text>
            <div class="headline mb-3">Blitz Unified Framework</div>
            <v-layout align-center justify-center>
              <div
                class="welcome-text subheading"
              >
              <p> Welcome to a product and business development exercise using the Blitz Unified Framework.</p>

              <p> In the first section, we will be working on developing a product concept using an innovation based framework called the <b>Blitz Innovation Framework</b>. </p>

              <p> In the second section, we will be work on business model development around the product concept, which we built as an outcome of the first section. </p>

              <p> Please choose the "Let's get started" button below to get started with this exercise. </p>

              
              </div>
            </v-layout>
          </v-card-text>

          <v-card-actions class="center">
            <v-layout column align-center justify-center>
              <v-btn dark color="primary" class="mb-3" router to="/bifprocessmodel">Let's get started!</v-btn>
              <!-- <v-btn class="mb-3" router to="/Home">Head back all options</v-btn> -->
              
            </v-layout>
          </v-card-actions>
        </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
// import HelloWorld from '../components/HelloWorld' Let's create my first product concept :)

export default {
  name: '',
  data(){
    return{ 
      
    }
  },
  components: {
    //HelloWorld
  }
};
</script>

<style>
.welcome-text {
  text-align: center;
}
</style>
